import { useColorMode } from "@chakra-ui/react";
import { useEffect } from "react";

export const ThemeToggler = () => {
  const { toggleColorMode } = useColorMode();

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.ctrlKey && event.key === "d") {
        event.preventDefault();
        toggleColorMode();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [toggleColorMode]);

  return null;
};
